import {useState,useEffect, useRef} from 'react'; 
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import {Tablescom} from '../../components/tablescomp';
import { Dialog } from 'primereact/dialog';
import {userservices} from '../../services/userServices';
import {productservices} from '../../services/productServices';
import { saleServices } from "../../services/saleServices";
import { AlertServices } from '../../services/alertServices';
import {Titlebar,Searchbox} from  '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate   } from "react-router";
import {DynamicHorizontalTable} from '../../components/dynamictables';


import { Toast } from "primereact/toast";
const AlertReminders = () =>{
    const toast = useRef(null);
    const navigate = useNavigate();
    const [users,setUsers] = useState([]);
    const [results,setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [userloaded,setUserloaded] = useState(false);
    const [quickFilterText, setQuickFilterText] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagination, setPagination] = useState({page:1,limit:10});
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});
   
    

    useEffect(()=>{
      getalertlist();
    },[]); 

  const [colDefs, setColDefs] = useState([
    { headerName: "SR NO",field: "id",width:100 },
    {headerName:"Product",field:"product"},
    { headerName: "Alert Type",field: "alert_type",cellRenderer: (params) => {
    const type = params.data.alert_type;

    let bgColor = "";
    let text = "";

    switch (type) {
      case 'low_stock':
        bgColor = "#ffe58f"; // yellow
        text = "Low Stock";
        break;
      case 'out_of_stock':
        bgColor = "#ff7875"; // red
        text = "Out of Stock";
        break;
      case 'expiry':
        bgColor = "#91d5ff"; // blue
        text = "Expiring Soon";
        break;
      case 'custom':
        bgColor = "#d3adf7"; // purple
        text = "Custom Alert";
        break;
      default:
        bgColor = "#f0f0f0";
        text = "Unknown";
    }

    return <Tag value={text} style={{backgroundColor:bgColor}}></Tag>;
  } },
    { headerName: "Product type",field: "product_type" },
    { headerName: "Low Stock threshold",field: "low_stock_threshold",cellRenderer: (params) => {
       return <><span>{params.data.low_stock_threshold}</span> <span className='text-success'>({params.data.low_stock_unit})</span></>
    } },
    { headerName: "Over Stock threshold",field: "over_stock_threshold",cellRenderer: (params) => {
       return <><span>{params.data.over_stock_threshold}</span> <span className='text-success'>({params.data.over_stock_unit})</span></>
    } },
    { headerName: "Sku code",field: "skucode" },
     { headerName: "Alert Frequency",width:40,field: "remind_after_days" },
    { headerName: "Action",
      cellStyle: {
       display:'flex',
       justifyContent:'center'
    },
    cellRenderer: (params) => {
      // console.log("params");
      // console.log(params.data.id);
      return (
        <>
             <button class="btn  btn-xs btn-primary" onClick={(e) => navigate(`/editalerts`, { state: params.data })}><i class="icon icon-note color-white"></i></button>
             &nbsp; 
             <button class="btn btn-danger btn-xs" onClick={(e) => deletealert(params.data.id)}><i class="icon icon-trash" ></i></button> 

             &nbsp;
            <button class="btn btn-success btn-xs" onClick={(e) => {}}><i class="icon icon-eye" ></i></button> 
        </>
       
      );
    } }
  ]);

 
  const deletealert = (id) =>{
        AlertServices.deletealert(id).then((response)=>{
          if(response.status == 200){
            toast.current.show({ severity: 'success', summary: 'Alert', detail: 'Alert deleted successfully' }); 
            getalertlist();   
          }
      }).catch((error)=>{
        
      }); 
  }


  const getalertlist  = ()=> {
        // setLoading(true);
        setUserloaded(true);
        AlertServices.getalertdata({pagination}).then((response)=>{
            if(response.status == 200){
                setResults(response.data.data.data);
                setTotalRows(response.data.data.total);
                setLoading(false);
                setUserloaded(false);
            }else{
              setResults([]);
                // setUsers([]);
                setUserloaded(false);
            }  
        }).catch((error)=>{
          setResults([]);
            // setUsers([]);
            setUserloaded(false);
        }); 
  } 

  const addalertnavigate = () =>{
    // navigate.  
    navigate('/addalerts');
  }

  const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    // getstocks(statusset, 1, newSize);       // reload with new size
  };

  const handleNext = () => {
    if (currentPage < Math.ceil(totalRows / pageSize)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  useEffect(() => {
    setPagination({page:currentPage,limit:pageSize});
    // getalertlist();
  }, [ currentPage, pageSize]);

  useEffect(() => {
    getalertlist();
    //  console.log('Current Page or Page Size changed:', pagination);
  }, [pagination]);


  const onRowClicked = (event) => {
    setSelectedRow(event.data);
    // console.log(event.data,'row clicked data');
    setModalIsOpen(true);
  };

  return(
       <>
        <Toast ref={toast} />
          {/* <Bredcrum title={'Alerts & Reminders'} divider={false}/> */}
          <div class="row">
              <div className='col-md-12 mb-2 mt-2'>
                 <div className='flex-box flex-between'>
                  <div>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ps-4 pe-4' onClick={() => addalertnavigate()}>Alert Setup</button>
                        &nbsp;&nbsp;
                       <button className='btn btn-dark rounded-pill ps-4 pe-4' onClick={() => addalertnavigate()}>Bulk Alerts</button>
                  </div>
                       
                      <Searchbox value={quickFilterText} onChange={(e) => setQuickFilterText(e.target.value)}/>
                  </div> 
              </div> 

              <Dialog visible={modalIsOpen} position='top' modal style={{ width: '100rem' }} onHide={() => { if (!modalIsOpen) return; setModalIsOpen(false); }}>
                          <div class="container">
                              {DynamicHorizontalTable({ data: selectedRow })}
                          </div>
                        </Dialog>
             
              
              {/* <Titlebar text={'Alerts & Reminders'}/> */}
              <div className="col-md-12 mt-3">
                  <div className='card'>
                    <div className='card-body card-body-style'>
                     {/* <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded}   loading={loading} pageSize={10}/> */}
                     <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} quickFilterText={quickFilterText} paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                  totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext}
                  handlePrevious={handlePrevious}
                  handlePageSizeChange={handlePageSizeChange} onRowClicked={onRowClicked}/>
                     </div>
                 </div>
              </div>   
          </div>
       </>
    );   
 }
 export default AlertReminders;